export enum Orientation {
    VERTICAL = "VERTICAL",
    HORIZONTAL = "HORIZONTAL"
}